import { render, staticRenderFns } from "./Ribbon.vue?vue&type=template&id=7927dbc3"
import script from "./Ribbon.vue?vue&type=script&lang=js"
export * from "./Ribbon.vue?vue&type=script&lang=js"
import style0 from "./Ribbon.vue?vue&type=style&index=0&id=7927dbc3&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports